import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Paper, Select, TextField, Theme, Typography } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { API_elaboraSchedaBudget, calcolaRedditivita } from '../../utils/functions';
import { SchedaBudgetInputProps } from './InformazioniCosti';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//             minWidth: 300,
//         },
//     }));

export default function Forfetari(props: SchedaBudgetInputProps) {
    // const classes = useStyles();
    const gClasses = globalStyles();
    const action = "changeForfetari";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleBlur = (e: any) => {
        API_elaboraSchedaBudget(props, global);
    }

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraSchedaBudget(props, global, name, value, action, true);
    }

    const handleChangeSelectGruppo = (e: any) => {
        let action = "changeGruppoDiSettore";
        let { name, value } = e.target;
        let valueReddito = calcolaRedditivita(e.target.value);

        props.handleChange(action, name, {gruppo: value, D46_reddito: valueReddito});
        API_elaboraSchedaBudget(props, global, "gruppoDiSettore", {gruppo: value, D46_reddito: valueReddito}, action, true);
    }    

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;

        if (name === "B28_professionista_senza_cassa_al_24" && checked === true && (state.forfetari.B29_professionista_senza_cassa_al_25_72 || state.forfetari.B30_professionista_con_cassa_autonoma)) {
            state.forfetari.B29_professionista_senza_cassa_al_25_72 = false;
            state.forfetari.B30_professionista_con_cassa_autonoma = false;
        }
        else if (name === "B29_professionista_senza_cassa_al_25_72" && checked === true && (state.forfetari.B28_professionista_senza_cassa_al_24 || state.forfetari.B30_professionista_con_cassa_autonoma)) {
            state.forfetari.B28_professionista_senza_cassa_al_24 = false;
            state.forfetari.B30_professionista_con_cassa_autonoma = false;
        }
        else if (name === "B30_professionista_con_cassa_autonoma" && checked === true && (state.forfetari.B28_professionista_senza_cassa_al_24 || state.forfetari.B29_professionista_senza_cassa_al_25_72)) {
            state.forfetari.B28_professionista_senza_cassa_al_24 = false;
            state.forfetari.B29_professionista_senza_cassa_al_25_72 = false
        }

        props.handleChange(action, name, checked);
        API_elaboraSchedaBudget(props, global, name, checked, action, true);
    };

    let showRilvalsa = (state.forfetari.tipologia === "ARTIGIANO" || state.forfetari.tipologia === "COMMERCIANTE") && state.forfetari.B34_impresa_familiare_1_collaboratore;
    let isProfessione = state.informazioniCostiDiAvvio.tipologia === "PROFESSIONE";
    let isProfessioneOImpresa= state.informazioniCostiDiAvvio.tipologia === "PROFESSIONE" || state.informazioniCostiDiAvvio.tipologia === "IMPRESA";
    let isImpresaIndividualeOFamigliare = state.informazioniCostiDiAvvio.tipologia === "IMPRESA" || state.informazioniCostiDiAvvio.tipologia === "IMPRESA_FAMILIARE";

    return (
        <Paper className={gClasses.mainPaper}>
            <SectionTitle text="Contribuenti Forfetari"></SectionTitle>
            {/* <Typography variant="body1" style={{ margin: "10px" }}>Gruppo di settore</Typography> */}
            <Grid direction="column">
                <Grid direction="row">
                    <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="gruppoDiSettore">Gruppo di Settore</InputLabel>
                    {isProfessione ?
                        (
                        <Select id="gruppoDiSettore" name="gruppoDiSettore" className={gClasses.select}
                            value={state.forfetari.gruppoDiSettore.gruppo} onChange={handleChangeSelectGruppo}>
                            <MenuItem value="Non definito" >Non definito</MenuItem>
                            <MenuItem value="Attività Professionali, Scientifiche, ecc.">Attività Professionali, Scientifiche, ecc.</MenuItem>
                        </Select>
                        )
                        :
                        (
                        <Select id="gruppoDiSettore" name="gruppoDiSettore" className={gClasses.selectLong}
                            value={state.forfetari.gruppoDiSettore.gruppo} onChange={handleChangeSelectGruppo}>
                            <MenuItem value="Non definito" >Non definito</MenuItem>
                            <MenuItem value="Industrie alimentari e delle bevande">Industrie alimentari e delle bevande</MenuItem>
                            <MenuItem value="Commercio all'ingrosso e al dettaglio">Commercio all'ingrosso e al dettaglio</MenuItem>
                            <MenuItem value="Commercio ambulante alimentari e bevande">Commercio ambulante alimentari e bevande</MenuItem>
                            <MenuItem value="Commercio ambulante di altri prodotti">Commercio ambulante di altri prodotti</MenuItem>
                            <MenuItem value="Costruzioni e attività immobiliari">Costruzioni e attività immobiliari</MenuItem>
                            <MenuItem value="Intermediari del commercio">Intermediari del commercio</MenuItem>
                            <MenuItem value="Attività dei Servizi di alloggio e di ristorazione">Attività dei Servizi di alloggio e di ristorazione</MenuItem>
                            <MenuItem value="Altre attività economiche">Altre attività economiche</MenuItem>
                        </Select>)
                    }
                    </FormControl>
                </Grid>
            </Grid>
            <SectionTitle text="Altri Dati"></SectionTitle>
            <Grid direction="column">
                {isProfessione ? <p></p> :
                    <Grid direction="row">
                        <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="tipologia">Tipologia</InputLabel>
                        <Select
                            className={gClasses.select}
                            value={state.forfetari.tipologia}
                            inputProps={{ name: 'tipologia', id: 'tipologia' }}
                            onChange={handleChangeSelect}>
                            <MenuItem value={"NON DEFINITO"}>Non definito</MenuItem>
                            <MenuItem value={"ARTIGIANO"}>Artigiano</MenuItem>
                            <MenuItem value={"COMMERCIANTE"}>Commerciante</MenuItem>
                        </Select>
                        </FormControl>
                    </Grid>
                }
                {isProfessione ? <p></p> :
                    <Grid direction="row">
                        <FormControlLabel className={gClasses.bottomControlLabelNoSpace}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.forfetari.B23_B26_riduzione_35}
                                    name='B23_B26_riduzione_35'
                                    id='B23_B26_riduzione_35'
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Riduzione 35% contribuiti IVS"
                        />
                    </Grid>
                }
                {isImpresaIndividualeOFamigliare ? <p></p> :
                    <Grid direction="row">
                        <FormControlLabel className={gClasses.bottomControlLabelNoSpace}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.forfetari.B28_professionista_senza_cassa_al_24}
                                    name='B28_professionista_senza_cassa_al_24'
                                    id='B28_professionista_senza_cassa_al_24'
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Prof. senza cassa al 24%"
                        />

                        <FormControlLabel className={gClasses.bottomControlLabelNoSpace}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.forfetari.B29_professionista_senza_cassa_al_25_72}
                                    name='B29_professionista_senza_cassa_al_25_72'
                                    id='B29_professionista_senza_cassa_al_25_72'
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Prof. senza cassa al 26,23%"
                        />
                    </Grid>
                }
                {isImpresaIndividualeOFamigliare ? <p></p> :
                    <Grid>
                        <FormControlLabel className={gClasses.bottomControlLabelNoSpace}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.forfetari.B30_professionista_con_cassa_autonoma}
                                    name='B30_professionista_con_cassa_autonoma'
                                    id='B30_professionista_con_cassa_autonoma'
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Prof. con cassa autonoma"
                        />
                        <NumberField
                            name="D30_professionista_con_cassa_autonoma_percentuale"
                            label="Contributi"
                            value={state.forfetari.D30_professionista_con_cassa_autonoma_percentuale}
                            //readOnly={true}
                            margin="dense"
                            className={gClasses.textField}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                    </Grid>
                }
                {isProfessioneOImpresa ? <p></p> :
                    <Grid direction="row">
                        <FormControlLabel className={gClasses.bottomControlLabelNoSpace}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.forfetari.B34_impresa_familiare_1_collaboratore}
                                    name='B34_impresa_familiare_1_collaboratore'
                                    id='B34_impresa_familiare_1_collaboratore'
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Impresa familiare (1 collaboratore)"
                        />
                        <FormControlLabel className={gClasses.bottomControlLabelNoSpace}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.forfetari.B35_rivalsa_contributi_ivs}
                                    name='B35_rivalsa_contributi_ivs'
                                    id='B35_rivalsa_contributi_ivs'
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Rivalsa contributi IVS"
                        />
                    </Grid>}
                <Grid direction="row">
                    <FormControlLabel className={gClasses.bottomControlLabelNoSpace}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.forfetari.B32_impostaSostitutiva}
                                name='B32_impostaSostitutiva'
                                id='B32_impostaSostitutiva'
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Imposta sostitutiva ridotta al 5% per i primi cinque anni"
                    />
                </Grid>
            </Grid>
            <SectionTitle text="Regime forfetario"></SectionTitle>
            <TextField
                label="Ditta/Professionista"
                value={state.informazioniCostiDiAvvio.nomeDitta}
                className={gClasses.longTextFieldReadOnly}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{tabIndex: -1}}
                margin="normal"
                InputProps={{
                    readOnly: true,
                }}
            />
            <Grid>
                <TextField
                    label="Attività esercitata"
                    value={state.forfetari.gruppoDiSettore.gruppo}
                    className={gClasses.longTextFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    margin="normal"
                    inputProps={{tabIndex: -1}}
                    InputProps={{
                        readOnly: true,
                    }}
                />

                <TextField
                    label="% Reddito"
                    name="D46_reddito"
                    value={state.forfetari.gruppoDiSettore.D46_reddito}
                    className={gClasses.textFieldReadOnly}
                    style={{ maxWidth: "70px" }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    margin="normal"
                    inputProps={{tabIndex: -1}}
                    InputProps={{
                        readOnly: true,
                    }}
                />
            </Grid>
            {/* Altri dati start */}
            {/* <SectionSubTitle text="Altri dati"></SectionSubTitle>
            <Grid direction="column">
                <TextField
                    label=""
                    value={
                        state.forfetari.B22_artigiano ? "Artigiano" :
                            state.forfetari.B25_commerciante ? "Commerciante" :
                                state.forfetari.B28_professionista_senza_cassa_al_24 ? "Prof. senza cassa al 24%" :
                                    state.forfetari.B29_professionista_senza_cassa_al_25_72 ? "Prof. senza cassa al 25,72%" :
                                        state.forfetari.B30_professionista_con_cassa_autonoma ? "Prof. con cassa autonoma" : ""

                    }
                    className={gClasses.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    margin="normal"
                    InputProps={{
                        readOnly: true,
                    }}
                />

                <TextField
                    label=""
                    value={(state.forfetari.B23_artigiano_riduzione_35 || state.forfetari.B26_commerciante_riduzione_35) ? "Riduzione 35% contributi IVS" : ""}
                    className={gClasses.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    margin="normal"
                    InputProps={{
                        readOnly: true,
                    }}
                />
                <TextField
                    label=""
                    value={state.forfetari.B32_impostaSostitutiva ? "Imposta sostitutiva ridotta al 5% per i primi cinque anni" : ""}
                    className={gClasses.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    margin="normal"
                    InputProps={{
                        readOnly: true,
                        style: { width: '25rem' },
                    }}
                />
            </Grid>
            <Grid direction="column">
                <TextField
                    label=""
                    value={state.forfetari.B34_impresa_familiare_1_collaboratore ? "IMPRESA FAMIGLIARE" : ""}
                    className={gClasses.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    margin="normal"
                    InputProps={{
                        readOnly: true,
                    }}
                />

                <TextField
                    label=""
                    value={state.forfetari.B35_rivalsa_contributi_ivs ? "RIVALSA CONTRIBUTI IVS" : ""}
                    className={gClasses.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    margin="normal"
                    InputProps={{
                        readOnly: true,
                    }}
                />
            </Grid> */}
            {/* Altri dati end */}

            <NumberField
                name="D56_ricavi_compensi"
                label="Ricavi/Compensi"
                value={state.forfetari.D56_ricavi_compensi}
                className={gClasses.textField}
                onChange={handleChange}
                onBlur={handleBlur}
            />

            <NumberField
                name="D58_reddito"
                label="Reddito"
                value={state.forfetari.D58_reddito}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />

            <NumberField
                name="D60_contributi_previdenziali"
                label="Contributi previdenziali"
                value={state.forfetari.D60_contributi_previdenziali}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />

            {showRilvalsa ?
                <NumberField
                    name="D62_rivalsa_contributi"
                    label="Rivalsa contributi"
                    value={state.forfetari.D62_rivalsa_contributi}
                    readOnly={true}
                    className={gClasses.textFieldReadOnly}
                />
                : <p></p>
            }
            <NumberField
                name="D64_imponibile"
                label="Imponibile"
                value={state.forfetari.D64_imponibile}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />

            <NumberField
                name="D66_imposta_sostitutiva"
                label={state.forfetari.B32_impostaSostitutiva ? "Imposta sostitutiva 5%" : "Imposta sostitutiva 15%"}
                value={state.forfetari.D66_imposta_sostitutiva}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />
            <NumberField
                name="D72_totale_imposta_contributi_oneri"
                label="Totale Imposta+Contributi"
                value={state.forfetari.D72_totale_imposta_contributi_oneri}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
            />

            <NumberField
                name="D74_reddito_netto_disponibile"
                label="Reddito netto disponibile"
                value={state.forfetari.D74_reddito_netto_disponibile}
                readOnly={true}
                className={gClasses.textFieldReadOnly}
                onChange={handleChange}
                onBlur={handleBlur}
            />

            <Typography variant="body1">
                Al fine di conferire maggiore efficacia alla simulazione, si ipotizzi una situazione a regime,
                per la quale si determina un risultato "di competenza", attraverso la deduzione dei contributi
                previdenziali direttamente dal reddito sul quale sono dovuti.
            </Typography>

        </Paper>
    )
}